//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SecuritySettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/security/settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.SecuritySettingsDto, unknown, Types.SecuritySettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SecuritySettingsDto, unknown, Types.SecuritySettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'SecuritySettingsClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

/**
 * Gets Security settings for current tenant.
 */
export function useGetQuery<TSelectData = Types.SecuritySettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.SecuritySettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.SecuritySettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SecuritySettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SecuritySettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.SecuritySettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets Security settings for current tenant.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.SecuritySettingsDto | undefined) => Types.SecuritySettingsDto, ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

/**
 * Gets Security settings for current tenant.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SecuritySettingsDto | undefined) => Types.SecuritySettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(): string {
  let url_ = getBaseUrl() + "/api/security/settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(): MutationKey {
  return trimArrayEnd([
      'SecuritySettingsClient',
      'patch',
    ]);
}

/**
 * Patches Security settings for current tenant.
 */
export function usePatchMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.SecuritySettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SecuritySettingsPatchDto, TContext> {
  const key = patchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SecuritySettingsPatchDto) => Client.patch(dto),
    mutationKey: key,
  });
}